import { IMarketingCampaignEntryEngagement } from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class MarketingCampaignEntryEngagement {
  static init(
    overrides: AtLeast<
      IMarketingCampaignEntryEngagement,
      'conversionType' | 'campaignRef' | 'campaignRunRef' | 'patientRef'
    >
  ): IMarketingCampaignEntryEngagement {
    return {
      deleted: false,
      ...overrides,
    };
  }
}
